import axios from 'axios';
export const TFDownloadFiles = (imageKey: string) => {
  const APIUrl =
    process.env.NODE_ENV === 'development'
      ? 'https://rmg.ibos.io'
      : window.location.origin;
  const downloadId = imageKey?.split('_')?.[0];
  axios({
    url: `${APIUrl}/rmg/Document/DownlloadFile?id=${downloadId}`,
    method: 'GET',
    responseType: 'blob', // important
  }).then((response) => {
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `${imageKey?.split('_')?.[1]}`);
    document.body.appendChild(link);
    link.click();
  });
};
